/*
 * Copyright 2026 Sony Corporation
 */

/**
 * Indicative list price per body, in USD.
 *
 * Hard-coded on purpose: nothing in the world or camera record carries a price,
 * and a quote is not something this service is the source of truth for. The BOM
 * shows a model with no entry here as unpriced rather than as free, so an
 * unrecognised model cannot silently understate a total.
 */
export const CAMERA_LIST_PRICE_USD: Record<string, number> = {
  'ILCE-1': 6498,
  'ILCE-7CR': 2998,
  'ILCE-7M4': 2498,
  'ILCE-7RM5': 3898,
  'ILCE-9M3': 5998,
  'ILCE-6700': 1398,
};

export const listPriceOf = (model: string): number | undefined => CAMERA_LIST_PRICE_USD[model];

export const formatUsd = (value: number): string =>
  value.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
